"use client";

import { useEffect } from "react";

// GlobalError renders its own <html>/<body> outside the provider tree,
// so useTranslations is unavailable. Use hardcoded fallback strings.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    import("@/lib/datadog-rum").then(({ addError }) => {
      addError(error, { source: "global-error-boundary" });
    });
  }, [error]);

  return (
    <html lang="en">
      <body className="antialiased min-h-screen flex items-center justify-center bg-white">
        <div className="text-center max-w-md px-6">
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">
            something went wrong
          </h1>
          <p className="text-gray-500 mb-6">
            an unexpected error occurred. please try again.
          </p>
          <button
            onClick={reset}
            className="px-4 py-2 bg-[#ff8086] text-white rounded-xl text-sm font-medium hover:opacity-90 transition-opacity"
          >
            try again
          </button>
        </div>
      </body>
    </html>
  );
}
